export type PhysicianTableObject = {
  label: string;
  value:
    | 'facilityName'
    | 'patientName'
    | 'documentType'
    | 'dateOfService'
    | 'dueDate'
    | ''
    | 'status';
  action?: string;
  sort?: boolean;
};
type TableHeads = Array<PhysicianTableObject>;

export const physicianTableHeads: TableHeads = [
  {
    label: 'Patient',
    value: 'patientName',
    sort: true,
  },
  {
    label: 'Facility Name',
    value: 'facilityName',
    sort: true,
  },
  {
    label: 'Document Type',
    value: 'documentType',
    sort: true,
  },
  {
    label: 'DOS',
    value: 'dateOfService',
    sort: true,
  },
  {
    label: 'Days Remaining',
    value: 'dueDate',
    sort: true,
  },
  {
    label: 'Status',
    value: 'status',
    sort: true,
  },
  {
    label: 'action',
    value: '',
    action: 'sign',
  },
];

export const physicianConst = {
  COMPLETED: 'COMPLETED',
  PENDING: 'PENDING',
};

export type physicianTableHeadersObject = {
  id: string;
  label: string;
  value: string;
  sortable?: boolean;
  filterable?: boolean;
  filterType?: 'date' | 'multiselect';
  filterOptions?: any[];
};

export const physicianTableHeaders: physicianTableHeadersObject[] = [
  {
    id: 'patientName',
    label: 'Patient',
    value: 'patientName',
    sortable: true,
    filterable: true,
    filterType: 'multiselect',
  },
  {
    id: 'facilityName',
    label: 'Facility Name',
    value: 'facilityName',
    sortable: true,
    filterable: true,
    filterType: 'multiselect',
  },
  {
    id: 'documentType',
    label: 'Document Type',
    value: 'documentType',
    sortable: true,
    filterable: true,
    filterType: 'multiselect',
  },
  {
    id: 'dateOfService',
    label: 'Date of Service',
    value: 'dateOfService',
    sortable: true,
    filterable: false,
    filterType: 'date',
  },
  {
    id: 'dueDate',
    label: 'Due Date',
    value: 'dueDate',
    sortable: true,
    filterType: 'date',
  },
  {
    id: 'status',
    label: 'Status',
    value: 'status',
    sortable: true,
    filterable: true,
    filterType: 'multiselect',
    filterOptions: ['OVERDUE', 'URGENT', 'UPCOMING', 'AWAITING SIGNATURE'],
  },
  {
    id: 'actions',
    label: 'Actions',
    value: 'actions',
  },
  {
    id: 'selected',
    label: 'Selected',
    value: 'selected',
  },
];
